
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="bg-white border border-gray-200 shadow-sm rounded-2xl p-8 md:p-12">
          <div className="relative overflow-hidden">
            {/* Removed the subtle gradient accent div */}
            
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between">
              {/* Decorative element as left border */}
              <div className="mb-6 md:mb-0 md:mr-8 pl-4 border-l-4 border-morgenBlue">
                <h2 className="text-2xl md:text-3xl font-bold mb-3 text-morgenDarkCharcoal">Ready to reduce PMPM and activate care at scale?</h2>
                <p className="md:text-lg text-gray-600">
                  Morgen partners with value-based orgs to unlock ROI through smarter engagement. Let's build it together.
                </p>
              </div>
              <div>
                <Button 
                  onClick={() => navigate('/contact')}
                  className="bg-morgen-gradient text-white hover:opacity-90"
                  size="lg"
                >
                  Request a Demo
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
